/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * An active public share link for a skill.
 */
export type SkillShareLink = {
  /**
   * When the share link was created.
   */
  createdAt: Date;
  /**
   * The public share token.
   */
  token: string;
};

/** @internal */
export const SkillShareLink$inboundSchema: z.ZodMiniType<
  SkillShareLink,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    token: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
    });
  }),
);

export function skillShareLinkFromJSON(
  jsonString: string,
): SafeParseResult<SkillShareLink, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillShareLink$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillShareLink' from JSON`,
  );
}
